import { ApiSchemas } from '..'
import { client } from '../client'
import { wrapEndpoint } from '../wrap'

export type AttendanceForm = ApiSchemas['AttendanceFormPresenter']

export type AttendanceFormStep = ApiSchemas['AttendanceFormStepPresenter']

export type AttendanceFormQuestion = ApiSchemas['AttendanceFormQuestionPresenter']

export type AttendanceFormAnswer = ApiSchemas['AttendanceFormAnswerPresenter']

export default {
  async get(id: number) {
    return wrapEndpoint(() =>
      client.GET('/attendance-form/{id}', {
        params: {
          path: { id },
        },
      }),
    )
  },
  async getTemplate() {
    return wrapEndpoint(() => client.GET('/attendance-form/template'))
  },
  async list(options?: ApiSchemas['ListAttendanceFormDto']) {
    return wrapEndpoint(() =>
      client.GET('/attendance-form', {
        params: {
          query: options,
        },
      }),
    )
  },
  async create(body: ApiSchemas['UpsertAttendanceFormDto']) {
    return wrapEndpoint(() =>
      client.POST('/attendance-form', {
        body,
      }),
    )
  },
  async update(id: number, body: ApiSchemas['UpsertAttendanceFormDto']) {
    return wrapEndpoint(() =>
      client.PUT('/attendance-form/{id}', {
        params: {
          path: { id },
        },
        body,
      }),
    )
  },
  async publish(id: number) {
    await wrapEndpoint(() =>
      client.PATCH('/attendance-form/{id}/publish', {
        params: {
          path: {
            id,
          },
        },
      }),
    )
  },
  async unpublish(id: number) {
    await wrapEndpoint(() =>
      client.PATCH('/attendance-form/{id}/unpublish', {
        params: {
          path: {
            id,
          },
        },
      }),
    )
  },
  async archive(id: number) {
    await wrapEndpoint(() =>
      client.PATCH('/attendance-form/{id}/archive', {
        params: {
          path: {
            id,
          },
        },
      }),
    )
  },
  async unarchive(id: number) {
    await wrapEndpoint(() =>
      client.PATCH('/attendance-form/{id}/unarchive', {
        params: {
          path: {
            id,
          },
        },
      }),
    )
  },
}
